var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box"},[_c('Title',{attrs:{"text":_vm.electricity.energyConsumptionDistribution.Title[0],"engText":_vm.electricity.energyConsumptionDistribution.Title[1]}}),_c('div',{staticClass:"content"},[_c('div',{staticClass:"echarts-content"},[_c('chart-block',{ref:"echart"})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }